module.exports = __webpack_public_path__ + "media/images/flags/4x3/niu-dbff33331c356722ce15a2388e2ef187.svg";